import React from 'react';
import { Button, useMediaQueryContext } from '@fourthwall/components';
import { Suggestion } from '@components/common/Suggestion';
import { routing } from '@utils/routing';
import { HighlightedBox } from '@components/common/HighlightedBox';
import creatorChallengeImg from '@modules/Dashboard/Home/modules/recommendations/assets/creator-challenge.png';
import * as S from './styled';
export const JoinCreatorChallengeContainer = ({ challengeReward }) => {
    const media = useMediaQueryContext();
    return (React.createElement(S.JoinChallengeContainer, null,
        React.createElement(Suggestion, { imageUrl: creatorChallengeImg, title: `Order samples today and we'll refund you ${challengeReward} if you can sell 6 products within 60 days!`, topLevelContent: React.createElement(HighlightedBox, { text: `Exclusive offer: ${challengeReward} of free sample credit` }), content: React.createElement(S.ButtonsWrapper, { "$fullWidth": media.tablet },
                React.createElement(Button, { fullWidth: !media.tablet, label: "Order samples now", analytics: "orderSamplesCreatorChallenge", appearance: "primary", to: `${routing.settings.samples.order}` })) })));
};
